export const ActionTypes = {
  FETCH_LINE_JOB_RECONCILIATION: 'services/dashboards/lineJobReconciliation/fetch_line_job_reconciliation',
  FETCH_ACCUMULATION_BY_ID_FILTER_BY_CURRENT_SHIFT:
    'services/dashboards/lineJobReconciliation/fetch_accumulation_by_id_filter_by_current_shift',
  FETCH_LINE_JOB_TOTAL_ACCUMULATION: 'services/dashboards/lineJobReconciliation/fetch_line_job_total_accumulation',
  FETCH_LINE_CURRENT_SHIFT_PRODUCTIONS:
    'services/dashboards/lineJobReconciliation/fetch_line_current_shift_productions',
  SET_LINE_JOB_RECONCILIATION: 'services/dashboards/lineJobReconciliation/set_line_job_reconciliation',
  ADD_LINE_REJECTION: 'services/dashboards/lineJobReconciliation/add_line_rejection',
  AUTO_RECONCILE: 'services/dashboards/lineJobReconciliation/auto_reconcile',
  UPDATE_LINE_REJECTION: 'services/dashboards/lineJobReconciliation/update_line_rejection',
  DELETE_LINE_REJECTION: 'services/dashboards/lineJobReconciliation/delete_line_rejection',
  ADD_REWORK: 'services/dashboards/lineJobReconciliation/add_rework',
  UPDATE_REWORK: 'services/dashboards/lineJobReconciliation/update_rework',
  DELETE_REWORK: 'services/dashboards/lineJobReconciliation/delete_rework',
  SET_ACCUMULATION_LOADER: 'services/dashboards/lineJobReconciliation/set_accumulation_loader',
  SET_AUTO_RECONCILE_LOADER: 'services/dashboards/lineJobReconciliation/auto_reconcile_loader',
  FETCH_NEW_LINE_JOB_ACCUMULATION: 'services/dashboards/lineJobReconciliation/fetch_new_line_job_accumulation',
  SET_NEW_LINE_JOB_ACCUMULATION: 'services/dashboards/lineJobReconciliation/set_new_line_job_accumulation',
  SET_LINE_JOB_EQUIPMENT_SHIFTS: 'services/dashboards/lineJobReconciliation/set_line_job_equipment_shifts',
  SET_LINE_JOB_EQUIPMENT_SHIFTS_LOADER:
    'services/dashboards/lineJobReconciliation/set_line_job_equipment_shifts_loader',
  FETCH_LINE_JOB_SHIFTS: 'services/dashboards/lineJobReconciliation/fetch_line_job_shifts',
  SET_LINE_JOB_SHIFTS: 'services/dashboards/lineJobReconciliation/set_line_job_shifts',
  SET_CURRENT_ACCUMULATION: 'services/dashboards/lineJobReconciliation/set_current_accumulation',
  SET_ACCUMULATION_MODAL_LOADER: 'services/dashboards/lineJobReconciliation/set_accumulation_modal_loader',
  SET_LINE_JOB_TOTAL_ACCUMULATION: 'services/dashboards/lineJobReconciliation/set_line_job_total_accumulation',
  SET_LINE_CURRENT_SHIFT_PRODUCTIONS: 'services/dashboards/lineJobReconciliation/set_line_current_shift_productions',
  ADD_GOOD_COUNT: 'services/dashboards/add_good_count',
  FETCH_FINISH_GOOD_REJECTION: 'services/dashboards/fetch_finish_good_rejection',
  SET_FINISH_GOOD_REJECTION: 'services/dashboards/set_finish_good_rejection',
};
const addLineRejection = ({ lineRejectionData, callback }) => ({
  lineRejectionData,
  callback,
  type: ActionTypes.ADD_LINE_REJECTION,
});
const addAutoReconcile = ({ autoReconcile, callback }) => ({
  autoReconcile,
  callback,
  type: ActionTypes.AUTO_RECONCILE,
});
const fetchAccumulationByIdAndFilterByCurrentShift = ({ id, isCurrentShift }) => ({
  id,
  isCurrentShift,
  type: ActionTypes.FETCH_ACCUMULATION_BY_ID_FILTER_BY_CURRENT_SHIFT,
});
const updateLineRejection = ({ lineRejectionData, callback }) => ({
  lineRejectionData,
  callback,
  type: ActionTypes.UPDATE_LINE_REJECTION,
});
const deleteLineRejection = ({ lineRejectionId, callback }) => ({
  lineRejectionId,
  callback,
  type: ActionTypes.DELETE_LINE_REJECTION,
});
const addRework = ({ reworkData, callback }) => ({
  reworkData,
  callback,
  type: ActionTypes.ADD_REWORK,
});
const updateRework = ({ reworkData, callback }) => ({
  reworkData,
  callback,
  type: ActionTypes.UPDATE_REWORK,
});
const deleteRework = ({ reworkId, callback }) => ({
  reworkId,
  callback,
  type: ActionTypes.DELETE_REWORK,
});
const fetchLineJobReconciliation = ({ jobId }) => ({
  jobId,
  type: ActionTypes.FETCH_LINE_JOB_RECONCILIATION,
});
const setLineJobReconciliation = ({ reconciliationData }) => ({
  reconciliationData,
  type: ActionTypes.SET_LINE_JOB_RECONCILIATION,
});

const fetchAccumulationsForNewJobByLineId = ({ lineId }) => ({
  lineId,
  type: ActionTypes.FETCH_NEW_LINE_JOB_ACCUMULATION,
});
const fetchLineJobTotalAccumulation = ({ jobId }) => ({
  jobId,
  type: ActionTypes.FETCH_LINE_JOB_TOTAL_ACCUMULATION,
});
const setAccumulationsForNewJob = ({ accumulationForNewJob }) => ({
  accumulationForNewJob,
  type: ActionTypes.SET_NEW_LINE_JOB_ACCUMULATION,
});
const setLineJobEquipmentShifts = ({ lineJobEquipmentShifts }) => ({
  lineJobEquipmentShifts,
  type: ActionTypes.SET_LINE_JOB_EQUIPMENT_SHIFTS,
});
const setLineJobEquipmentShiftsLoader = ({ lineJobEquipmentShiftsLoader }) => ({
  lineJobEquipmentShiftsLoader,
  type: ActionTypes.SET_LINE_JOB_EQUIPMENT_SHIFTS_LOADER,
});

const fetchLineJobShifts = ({ lineJobId }) => ({
  lineJobId,
  type: ActionTypes.FETCH_LINE_JOB_SHIFTS,
});
const setLineJobShifts = ({ lineJobShifts }) => ({
  lineJobShifts,
  type: ActionTypes.SET_LINE_JOB_SHIFTS,
});
const setCurrentAccumulation = ({ currentAccumulation }) => ({
  currentAccumulation,
  type: ActionTypes.SET_CURRENT_ACCUMULATION,
});
const setAccumulationModalLoader = ({ accumulationModalLoader }) => ({
  accumulationModalLoader,
  type: ActionTypes.SET_ACCUMULATION_MODAL_LOADER,
});

const setLineJobTotalAccumulation = ({ lineJobTotalAccumulation }) => ({
  lineJobTotalAccumulation,
  type: ActionTypes.SET_LINE_JOB_TOTAL_ACCUMULATION,
});
const setLineCurrentShiftProductions = ({ lineCurrentShiftProductions }) => ({
  lineCurrentShiftProductions,
  type: ActionTypes.SET_LINE_CURRENT_SHIFT_PRODUCTIONS,
});
const fetchLineCurrentShiftProductions = ({ lineJobId }) => ({
  lineJobId,
  type: ActionTypes.FETCH_LINE_CURRENT_SHIFT_PRODUCTIONS,
});

const addGoodCount = ({ goodCountData, callback }) => ({
  goodCountData,
  callback,
  type: ActionTypes.ADD_GOOD_COUNT,
});
const fetchFinishGoodRejection = ({ lineJobId, positionId, isCurrentShift }) => ({
  lineJobId,
  positionId,
  isCurrentShift,
  type: ActionTypes.FETCH_FINISH_GOOD_REJECTION,
});
const setFinishGoodRejection = ({ finishGoodRejection }) => ({
  finishGoodRejection,
  type: ActionTypes.SET_FINISH_GOOD_REJECTION,
});
const setAccumulationLoader = ({ showLoader }) => ({ showLoader, type: ActionTypes.SET_ACCUMULATION_LOADER });
const setAutoReconcileLoader = ({ showAutoReconcileLoader }) => ({
  showAutoReconcileLoader,
  type: ActionTypes.SET_AUTO_RECONCILE_LOADER,
});
export default {
  addLineRejection,
  updateLineRejection,
  deleteLineRejection,
  addRework,
  updateRework,
  deleteRework,
  setAccumulationLoader,
  setAutoReconcileLoader,
  fetchLineJobReconciliation,
  setLineJobReconciliation,
  fetchAccumulationsForNewJobByLineId,
  fetchAccumulationByIdAndFilterByCurrentShift,
  setAccumulationsForNewJob,
  setLineJobEquipmentShifts,
  setLineJobEquipmentShiftsLoader,
  fetchLineJobShifts,
  setLineJobShifts,
  fetchLineJobTotalAccumulation,
  setLineJobTotalAccumulation,
  setCurrentAccumulation,
  setAccumulationModalLoader,
  fetchLineCurrentShiftProductions,
  setLineCurrentShiftProductions,
  addGoodCount,
  fetchFinishGoodRejection,
  setFinishGoodRejection,
  addAutoReconcile,
};
